import { AdministrativeArea } from './AdministrativeArea'
import { Catchment } from './Catchment'
import { ITimeAndCityLocalizable } from './ITimeAndCityLocalizable'
import { TimeStep } from './TimeStep'

export class TimeStepMax extends TimeStep {
  constructor(
    snapshot: ITimeAndCityLocalizable,
    readonly administrativeArea: Array<AdministrativeArea>,
    readonly catchments: Array<Catchment>,
  ) {
    super(snapshot, snapshot.timestamp, 'Max')
  }

  getAdministrativeAreaValueFor(area_name: string): number {
    const area = this.administrativeArea.find((area) => area.area_name === area_name)
    return area ? area.return_period : 0
  }

  public isEmpty(): boolean {
    return this.administrativeArea.length === 0 && this.catchments.length === 0
  }
}
